<template>
  <StepComponent>
    <v-row>
      <v-col>
        <AccountIdCardContent />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="client.title"
          maxlength="120"
          label="Business Name"
          :rules="rules.businessOrNames"
          id="title"
          disabled
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="client.first_name"
          maxlength="120"
          label="First Name"
          id="firstName"
          :rules="rules.businessOrFirstName"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="client.last_name"
          maxlength="120"
          id="lastName"
          label="Last Name"
          :rules="rules.businessOrLastName"
        ></v-text-field>
      </v-col>
    </v-row>
  </StepComponent>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import StepComponent from "@/components/registration/AccountSetupSteps/StepComponent";
import AccountIdCardContent from "@/components/clients/account/AccountIdCardContent";
import { mapFields } from "vuex-map-fields";

export default {
  name: "AccountInformationStep",
  components: { StepComponent, AccountIdCardContent },
  computed: {
    ...mapGetters("clients", ["selectedClient"]),
    ...mapFields("clients", [
      "items[0].title",
      "client",
      "items[0].first_name",
      "items[0].last_name"
    ]),
    rules() {
      let componentRules = {};

      const businessOrName = field => {
        return () => {
          return (
            !!this.title ||
            !!field ||
            "Business Name or First/Last Name are required"
          );
        };
      };

      const businessOrNames = () => {
        return (
          !!this.title ||
          !!this.first_name ||
          !!this.last_name ||
          "Business Name or First/Last Name are required"
        );
      };

      const lettersOnly = value => {
        return /^[A-Za-z ]+$/.test(value || "") || "Only letters are allowed";
      };

      // Apply the rules
      componentRules.businessOrNames = [businessOrNames];
      componentRules.businessOrFirstName = [
        businessOrName(this.first_name),
        lettersOnly
      ];
      componentRules.businessOrLastName = [
        businessOrName(this.last_name),
        lettersOnly
      ];
      componentRules.title = [lettersOnly];

      return componentRules;
    }
  },
  methods: {
    ...mapActions("clients", ["updateAccountInfo"]),
    beforeContinue() {
      return this.updateAccountInfo().catch(e => {
        console.error(e);
        return false;
      });
    },
    resetValidation() {
      this.$emit("resetValidation");
    }
  },
  mounted() {
    this.client = this.selectedClient;
  }
};
</script>
